.calendar {
  --calendar-cell-not-in-view-color: #bfbfbf;

  border: var(--rc-theme-border-base);
  border-radius: var(--rc-theme-border-radius-base);

  :global(.ant-picker-cell):not(:global(.ant-picker-cell-in-view)) {
    color: var(--calendar-cell-not-in-view-color);
  }

  :global(.ant-picker-cell-today) {
    :global(.ant-picker-cell-inner) {
      border: var(--rc-theme-border-base);
    }
  }

  &.hide-mode-switch {
    :global(.ant-picker-calendar-mode-switch) {
      display: none;
    }

    :global(.ant-select) {
      width: 100%;
    }
  }

  .selected-week {
    background: var(--rc-theme-color-primary-default);
    color: var(--rc-theme-color-surface-default);
  }

  .selected-week:hover :global(.ant-picker-cell-inner) {
    border: var(--rc-theme-border-base);
  }

  &.month-selection-mode :global(.ant-picker-cell.ant-picker-cell-selected) {
    :global(.ant-picker-cell-inner) {
      background: none;
      color: var(--rc-theme-color-text-default);
    }
  }

  /* stylelint-disable-next-line selector-max-compound-selectors */
  &.week-selection-mode :global(.ant-picker-content tbody tr:hover) .week-cell {
    background: var(--ant-calendar-cell-hover-bg);
    color: var(--rc-theme-color-text-heading);
  }

  /* stylelint-disable-next-line selector-max-compound-selectors */
  &.week-selection-mode :global(.ant-picker-content tbody tr:hover) .selected-week {
    background: var(--rc-theme-color-primary-default);
    color: var(--rc-theme-color-surface-default);
  }

  /* stylelint-disable-next-line selector-max-compound-selectors */
  :global(.ant-picker-content tbody tr td:first-child) .selected-week,
  /* stylelint-disable-next-line selector-max-compound-selectors */
  &.week-selection-mode :global(.ant-picker-content tbody tr:hover td:first-child) .week-cell {
    margin-left: var(--rc-theme-spacing-xs);
    border-top-left-radius: var(--rc-theme-border-radius-base);
    border-bottom-left-radius: var(--rc-theme-border-radius-base);

    /* stylelint-disable-next-line selector-max-compound-selectors -- ant design nested selector */
    :global(.ant-picker-cell-inner) {
      margin-left: calc(-1 * var(--rc-theme-spacing-xs));
    }
  }

  /* stylelint-disable-next-line selector-max-compound-selectors */
  :global(.ant-picker-content tbody tr td:last-child) .selected-week,
  /* stylelint-disable-next-line selector-max-compound-selectors */
  &.week-selection-mode :global(.ant-picker-content tbody tr:hover td:last-child) .week-cell {
    margin-right: var(--rc-theme-spacing-xs);
    border-top-right-radius: var(--rc-theme-border-radius-base);
    border-bottom-right-radius: var(--rc-theme-border-radius-base);

    /* stylelint-disable-next-line selector-max-compound-selectors -- ant design nested selector */
    :global(.ant-picker-cell-inner) {
      margin-right: calc(-1 * var(--rc-theme-spacing-xs));
    }
  }
}
